import Model from './model.js';

export default class Person extends Model
{
    get FullName(){
        return `${this.firstName} ${this.secondName} ${this.thirdName} ${this.forthName}`
    }
      
    get ThirdName(){
        return `${this.firstName} ${this.secondName} ${this.thirdName}`
    }

    constructor(code, id, firstName, secondName, thirdName, forthName, lastName, dateOfBirth, motherName, maritalStatus, bloodType, nationalitie, religion, doctrine, gender, note){ 
        super()
        this.code           = code ?? 0
        this.id             = id ?? 0
        this.firstName      = firstName
        this.secondName     = secondName
        this.thirdName      = thirdName
        this.forthName      = forthName
        this.lastName       = lastName
        this.dateOfBirth    = dateOfBirth
        this.motherName     = motherName
        this.maritalStatus  = maritalStatus
        this.bloodType      = bloodType
        this.nationalitie   = nationalitie
        this.religion       = religion
        this.doctrine       = doctrine
        this.gender         = gender
        this.note           = note

        // Related Data to Person
        this.personType     = null
        this.residence      = null
        this.archiveFiles   = []
        this.members        = [];
        this.profileStatistics = null

        this.init()
    }
    
    setPersonType(personType){
        this.personType = personType
        return this
    }

    setResidence(residence){
        this.residence = residence
        return this
    }

    setArchiveFiles(archiveFiles){
        this.archiveFiles = archiveFiles
        return this
    }

    setMembers(members){
        this.members = members
        return this
    }
    
    setProfileStatistics(profileStatistics){
        this.profileStatistics = profileStatistics
        return this
    }

    update(data){
        Object.assign(this, data)
    }
    
    mapToCreate(){
        return {
            firstName:          this.firstName              ?? null,
            secondName:         this.secondName             ?? null,
            thirdName:          this.thirdName              ?? null,
            forthName:          this.forthName              ?? null,
            lastName:           this.lastName               ?? null,
            dateOfBirth:        this.dateOfBirth            ?? null,
            // motherName:         this.motherName             ?? null,
            maritalStatus:      this.maritalStatus?.value   ?? null,
            bloodType:          this.bloodType?.value       ?? null,
            nationalityEnum:    this.nationalitie?.value    ?? null,
            religion_Enum:      this.religion?.value        ?? null, // change name to religionEnum in next time
            doctrine_Enum:      this.religion?.value == 1 ? (this.doctrine?.value ?? null) : null, // change name to doctrineEnum in next time
            gender:             this.gender?.value          ?? 0,
            notes:              this.note                   ?? null,
        }
    }

    mapToUpdate(){
        return {
            firstName:          this.firstName              ?? null,
            secondName:         this.secondName             ?? null,
            thirdName:          this.thirdName              ?? null,
            forthName:          this.forthName              ?? null,
            lastName:           this.lastName               ?? null,
            dateOfBirth:        this.dateOfBirth            ?? null,
            motherName:         this.motherName             ?? null,
            maritalStatus:      this.maritalStatus?.value   ?? null,
            bloodType:          this.bloodType?.value       ?? null,
            nationalityEnum:    this.nationalitie?.value    ?? null,
            religionEnum:       this.religion?.value        ?? null,
            doctrineEnum:       this.religion?.value == 1 ? (this.doctrine?.value ?? null) : null,
            gender:             this.gender?.value          ?? null,
            notes:              this.note                   ?? null,
        }
    }
}

